import { getToolMetadata } from "src/reusable/Chat/AssistantMessage/artifacts/toolStatusUtils";
import { TArtifact } from "src/views/assistant/types";

// The plan-mutating tools that emit tool_metadata.plan_id on the backend.
const PLAN_TOOLS_WITH_METADATA = new Set([
  "create_plan",
  "checkout_plan",
  "update_plan",
  "complete_plan",
]);

/**
 * Extract plan_ids from plan-tool responses (Create/Checkout/Update/Complete
 * Plan). Prefers the structured tool_metadata sideband field; falls back to
 * regex-scraping the prose "Plan ID:" label for artifacts from a backend
 * that hasn't deployed the tool_metadata field yet.
 */
export function extractPlanIdsFromArtifacts(
  artifacts: Record<string, TArtifact>,
): string[] {
  const ids = new Set<string>();
  Object.values(artifacts).forEach((artifact: TArtifact) => {
    const tool = artifact.toolName?.toLowerCase().replace(/ /g, "_");
    if (!tool || !PLAN_TOOLS_WITH_METADATA.has(tool)) return;
    const raw = artifact.content?.text;
    if (raw == null) return;
    const metaPlanId = getToolMetadata(raw)?.plan_id;
    if (typeof metaPlanId === "string" && metaPlanId) {
      ids.add(metaPlanId);
      return;
    }
    const haystack = typeof raw === "string" ? raw : JSON.stringify(raw);
    const match = haystack.match(/Plan ID:\s*([a-f0-9]+)/i);
    if (match) ids.add(match[1]);
  });
  return Array.from(ids).sort();
}
